export default () => ({
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});
